export default "__VITE_ASSET__Chp2TacC__"